var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 10,
    viewBox: "0 0 36 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80906 5.24291H0.117188V6.291H4.80906V5.24291Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80906 3.49568H0.117188V4.54377H4.80906V3.49568Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80906 1.74723H0.117188V2.79531H4.80906V1.74723Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81314 0L0.730888 1.04809H5.53099V5.69667L6.61324 4.64858V0H1.81314Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0543 2.54131C30.764 2.32922 30.3209 2.17633 29.8982 2.17633C28.7752 2.17633 28.164 3.3021 28.164 4.36375C28.164 4.92725 28.2977 5.84094 29.2628 5.84094C29.4067 5.84094 29.5264 5.82614 29.6474 5.79162L29.8676 4.27867H31.0925L30.8353 6.03946C30.2585 6.26757 29.7569 6.35635 29.1495 6.35635C27.7668 6.35635 26.9265 5.67941 26.9265 4.37731C26.9265 3.0074 27.9068 1.68557 29.832 1.68557C30.3375 1.68557 30.7627 1.78792 31.2058 1.99753L31.0543 2.54131Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9891 6.291L14.6525 1.74723H13.4276L12.7642 6.291H13.9891Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2804 2.23674L12.3517 1.74723H9.6219L8.95982 6.291H11.6896L11.7609 5.80271H10.256L10.4966 4.15166H11.8934L11.957 3.71517H10.5603L10.7755 2.23674H12.2804Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0459 2.23674L35.1172 1.74723H32.3874L31.7253 6.291H34.4551L34.5264 5.80271H33.0214L33.2621 4.15166H34.6588L34.7225 3.71517H33.3257L33.5409 2.23674H35.0459Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5842 2.23674L18.6555 1.74723H15.9257L15.2636 6.291H16.4885L16.8004 4.15166H18.1971L18.2608 3.71517H16.8641L17.0792 2.23674H18.5842Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3148 2.23674L22.3861 1.74723H19.6563L18.9942 6.291H20.2178L20.5297 4.15166H21.9265L21.9901 3.71517H20.5934L20.8098 2.23674H22.3148Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.135 6.291H26.2911L25.3082 1.74476H24.464L21.8106 6.291H22.4765L23.3257 4.84094H24.8167L25.135 6.291ZM23.5817 4.40444L24.4105 2.9889L24.7212 4.40444H23.5817Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12916 8.43403H9.41054V9.96177H9.12916V8.43403Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89564 8.43403H10.3235L10.7449 9.50432L11.1702 8.43403H11.5941V9.96177H11.3268V8.69297H11.3217L10.8429 9.96177H10.6469L10.1668 8.69297H10.163V9.96177H9.89564V8.43403Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.092 8.43403H12.5198L12.9412 9.50432L13.3665 8.43403H13.7905V9.96177H13.5231V8.69297H13.5193L13.0405 9.96177H12.8445L12.3644 8.69297H12.3594V9.96177H12.092V8.43403Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0319 8.39457C15.5246 8.38594 15.8722 8.7053 15.8722 9.19482C15.8722 9.67201 15.5246 9.99137 15.0319 10C14.5455 10 14.1979 9.68064 14.1979 9.20345C14.1979 8.71393 14.5455 8.39457 15.0319 8.39457ZM15.0344 9.75462C15.3616 9.75462 15.5781 9.51295 15.5781 9.18742C15.5781 8.88286 15.3616 8.64118 15.0344 8.64118C14.7085 8.64118 14.4933 8.88286 14.4933 9.18742C14.492 9.51295 14.7085 9.75462 15.0344 9.75462Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.272 8.43403H16.887C17.1251 8.43403 17.3708 8.54007 17.3708 8.81874C17.3708 8.99137 17.2588 9.10604 17.0971 9.1529V9.1566C17.2957 9.17879 17.4383 9.32922 17.4383 9.52528C17.4383 9.8582 17.1391 9.96177 16.8412 9.96177H16.2733V8.43403H16.272ZM16.5534 9.05549H16.8093C16.9965 9.05549 17.0907 8.9778 17.0907 8.86313C17.0907 8.7312 16.9965 8.66708 16.7851 8.66708H16.5534V9.05549ZM16.5534 9.72873H16.8119C16.957 9.72873 17.1569 9.7053 17.1569 9.50432C17.1569 9.34525 17.05 9.28853 16.8233 9.28853H16.5534V9.72873Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8432 8.43403H18.1246V9.96177H17.8432V8.43403Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6033 8.43403H18.8847V9.7164H19.5557V9.96301H18.6046V8.43403H18.6033Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8867 8.43403H20.1681V9.96177H19.8867V8.43403Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6469 8.43403H21.6922V8.68064H20.9282V9.05672H21.6527V9.30333H20.9282V9.71763H21.7329V9.96424H20.6481V8.43403H20.6469Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1416 8.43403H22.6904C22.9934 8.43403 23.2786 8.52898 23.2786 8.87176C23.2786 9.09248 23.1475 9.25401 22.9132 9.28607L23.3321 9.96177H22.9934L22.628 9.31443H22.423V9.96177H22.1416V8.43403ZM22.6407 9.08138C22.7986 9.08138 22.9845 9.06905 22.9845 8.8693C22.9845 8.68804 22.8101 8.66584 22.6662 8.66584H22.423V9.08015H22.6407V9.08138Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSm);
export default __webpack_public_path__ + "static/media/logoSm.ba0e9ad3113fe04cfd209cfa8e910927.svg";
export { ForwardRef as ReactComponent };